import {InjectionToken, Provider} from '@angular/core';

export const CAROUSEL_SCROLL_AMOUNT = new InjectionToken<number>(
  'Provides a value for horizontal scroll carousel event.',
);

export const CAROUSEL_PROVIDERS: Provider[] = [
  {
    provide: CAROUSEL_SCROLL_AMOUNT,
    useValue: 450,
  },
];
